import * as React from "react";
import { createWorkbook } from "../../actions/createWorkbook";
import { updateWorkbook } from "../../actions/updateWorkbook";
import { smallNums } from "../../HelperSrc";
import { lang } from "../../lang";
import { Workbook } from "../../interface";
import { store } from "../../store";
import { Button } from "../../components/atoms/Button";
import { Checkbox } from "../../components/atoms/Checkbox";
import { FlexHorizontal, FlexSpacer } from "../../components/atoms/Flex";
import { InputField } from "../../components/atoms/InputField";
import { Title } from "../../components/atoms/Text";
import { Popup } from "../../components/molecules/Popup";
import { catchEndpoint } from "../../catchEndpoint";

class CreateWorkbook extends React.Component<{
    onClose: (ok?: boolean) => void;
    edit: Workbook;
}> {
    public state = {
        nameError: "",
        yearError: "",
        name: "",
        year: "",
        isPrimary: false,
        wasPrimary: false,
        lock: false,
        edit: false
    };
    public componentDidMount(): void {
        const { edit } = this.props;
        if (edit) {
            this.setState({
                name: edit.name,
                year: String(edit.year),
                isPrimary: edit.is_primary,
                wasPrimary: edit.is_primary,
                edit: true
            });
        }
    }
    public validate = (): boolean => {
        const { year, name, isPrimary, wasPrimary } = this.state;
        this.setState({ nameError: "", yearError: "" });
        if (!name.match(/.{3,20}/)) {
            this.setState({ nameError: lang.invalidName });
            return false;
        } else if (!year.match(/^(2|２)[0-9０-９]{3}$/)) {
            this.setState({ yearError: lang.invalidYear });
            return false;
        } else if (isPrimary && !wasPrimary && store.workbooks.findIndex((workbook) => Math.abs((workbook.year || 0) - Number(year)) < 0.1) !== -1) {
            this.setState({
                yearError: "Primary workbook already exists for this year."
            });
            return false;
        }
        return true;
    };
    public createWorkbook = (e: React.FormEvent<HTMLFormElement>): void => {
        e.preventDefault();
        if (this.state.lock) {
            return;
        }
        if (this.validate()) {
            const { name, year, isPrimary } = this.state;
            this.setState({ lock: true });
            if (!this.props.edit) {
                createWorkbook(name, Number(smallNums(year)), isPrimary)
                    .catch(catchEndpoint)
                    .finally(() => {
                        this.props.onClose(true);

                        store.doNotice(lang.createWorkbook, true);
                    });
            } else {
                const { id } = this.props.edit;
                if (!id) return;
                updateWorkbook(id, name, Number(smallNums(year)), isPrimary)
                    .catch(catchEndpoint)
                    .finally(() => {
                        this.props.onClose(true);

                        store.doNotice(lang.updateWorkbook, true);
                    });
            }
        }
    };
    public formChange = (text: string, name: string): void => {
        const state = this.state;
        state[name] = text;
        this.setState(state);
    };
    public render(): React.ReactElement {
        const { nameError, yearError, isPrimary } = this.state;
        return (
            <Popup
                onClose={() => {
                    if (this.state.lock) {
                        return;
                    }
                    this.props.onClose();
                }}
            >
                <Title className="title_create">{this.state.edit ? lang.editWorkbook : lang.newWorkbook}</Title>
                <form onSubmit={this.createWorkbook}>
                    <InputField
                        id="workbookname"
                        data-at_id="workbook_name"
                        name="name"
                        autoFocus
                        title={lang.workbookName}
                        type="text"
                        onChangeField={this.formChange}
                        value={this.state.name}
                        error={nameError}
                    />
                    <InputField
                        id="workbookyear"
                        data-at_id="workbook_year"
                        name="year"
                        title={lang.workbookYear}
                        step={1}
                        type="text"
                        onChangeField={this.formChange}
                        value={this.state.year}
                        error={yearError}
                    />
                    <Checkbox
                        id="isprimary"
                        data-at_id="workbook_is_primary"
                        title={lang.isPrimary}
                        checked={isPrimary}
                        type="checkbox"
                        onChange={(v) => {
                            this.setState({
                                isPrimary: v.currentTarget.checked
                            });
                        }}
                    />
                    <FlexHorizontal>
                        <FlexSpacer />
                        <Button
                            id="createworkbookbtn"
                            data-at_id="create_workbook_button"
                            disabled={this.state.lock}
                            loading={this.state.lock}
                            submit
                            right
                            title={this.props.edit ? lang.update : lang.create}
                            style={{ flex: 1, marginBottom: "-5px" }}
                        />
                    </FlexHorizontal>
                </form>
            </Popup>
        );
    }
}

export { CreateWorkbook };
